// returns parsed object out of stringified object
export const parseStringifiedJsonObj = (strObj) => {
  try {
    const obj = JSON.parse(strObj);

    return obj;
  } catch (error) {
    return {};
  }
};
